import { normalizeInboxIdList } from './inboxIdsNormalize';

/**
 * Filtros do gatilho `conversation_created` em `node.data.conversation_filters`.
 *
 * - `inbox_ids`: lista de IDs numéricos de caixas. Vazia = todas as caixas.
 */

export function defaultConversationFilters() {
  return {
    inbox_ids: [],
    pause_for_human: false,
    pause_after_human_minutes: 30,
  };
}

export function normalizeConversationFilters(raw) {
  if (!raw || typeof raw !== 'object') {
    return { ...defaultConversationFilters() };
  }
  return {
    inbox_ids: normalizeInboxIdList(raw.inbox_ids),
    pause_for_human: raw.pause_for_human === true,
    pause_after_human_minutes: Math.max(
      1,
      Number(raw.pause_after_human_minutes) || 30
    ),
  };
}
